(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("AccountSettingsCtrl", ["accountsResource", "frameworkService", "rolesResource", "$scope", "$rootScope", "$timeout", "messageService", "_", "profileRecord", "$state", "USER_ROLES", "CONST_ALLROLES", accountSettingsCtrl]);
    function accountSettingsCtrl(accountsResource, frameworkService, rolesResource, $scope, $rootScope, $timeout, messageService, _, profileRecord, $state, USER_ROLES, CONST_ALLROLES) {
        var vm = this;
        vm.saving = false;
        var person = $state.params.personSeq;
        vm.profileRecord = profileRecord;
        vm.accountStatus = vm.profileRecord.userStatusId;
        vm.currentRoles = [];
        vm.rolesThatCannotBeEdited = [];
        vm.roles = [];
        //Get List of Roles this Admin can Assign (Assignable Roles)
        rolesResource.getCurrentUserRoles(function (data) {
            angular.forEach(data, function (role) {
                if (role.name === USER_ROLES.forumModerator && !frameworkService.data.tenantFeatures.forums)
                    return;
                else if (role.name === USER_ROLES.organizationAdmin && !frameworkService.data.tenantFeatures.organization)
                    return;
                else if (role.name === USER_ROLES.groupAdmin && !frameworkService.data.tenant.hasGroups)
                    return;
                var role = _.find(CONST_ALLROLES, { name: role.name });
                if (role)
                    vm.roles.push(role);
            });
            vm.profileRecord.roles.forEach(function (item) {
                var role = _.find(vm.roles, { name: item.name });
                if (role) {
                    vm.currentRoles.push(role.name);
                    if (role.name === USER_ROLES.siteAdmin)
                        vm.siteAdminChecked = true;
                }
                else {
                    vm.rolesThatCannotBeEdited.push(item.name);
                }
            });
        });
        vm.checkBoxClicked = function (roleName) {
            if (roleName === USER_ROLES.siteAdmin) {
                $timeout(function () {
                    var index = vm.currentRoles.indexOf(USER_ROLES.siteAdmin);
                    if (index >= 0) {
                        //uncheck org and group admin
                        vm.siteAdminChecked = true;
                        var roles = angular.copy(vm.currentRoles);
                        vm.currentRoles = [];
                        angular.forEach(roles, function (role) {
                            if (role === USER_ROLES.organizationAdmin || (role === USER_ROLES.groupAdmin))
                                return;
                            vm.currentRoles.push(role);
                        });
                    }
                    else {
                        vm.siteAdminChecked = false;
                    }
                });
                //vm.roles = angular.copy(vm.roles);
            }
        };
        vm.save = function () {
            vm.saving = true;
            //var model = { id: vm.profileRecord.id, accountState: vm.accountStatus, roles: _.union(_.pluck(vm.currentRoles, "name"), vm.rolesThatCannotBeEdited) };
            var model = { id: vm.profileRecord.id, accountState: vm.accountStatus, roles: _.union(vm.currentRoles, vm.rolesThatCannotBeEdited) };
            accountsResource.updateAccountSettings({ personSeq: person }, model, function () {
                messageService.success("account.profile.accountSettings.updated");
                vm.profileRecord.roles = _.map(model.roles, function (n) { return { name: n }; });
                vm.profileRecord.userStatusId = vm.accountStatus;
                $scope.$close(vm.profileRecord);
                $rootScope.$broadcast("checkSubscription");
                vm.saving = false;
            }, function (error) {
                vm.saving = false;
                messageService.error(error);
            });
        };
    }
}());
